module.exports = __webpack_public_path__ + "img/让我看看.20c287ff.png";